import React, { useEffect } from 'react'
import {
  SideRail
} from '@digicert/dcone-common-ui'
import cn from 'classnames'
import { Translate } from 'react-localize-redux'
import { UserUpdateType } from './user-overview/UserOverview.types'
import styles from './UserDetails.module.scss';
import AccountAccess from './account-access/AccountAccess'
import ResetUserCredentials from './reset-user-credentials/ResetUserCredentials'
import { IAccessScope, IApplication } from 'reducers/Reducers.interfaces'
import { CERT_CENTRAL_SHORT_APP_CODE } from 'core/constants'
import { editUser } from 'core/actions/Users.actions'
import { connect } from 'react-redux'
import UpdateServices from './update-services/UpdateServices'
import UpdateUser from './update-user/UpdateUser'
import Cookies from 'js-cookie'
import { ACCOUNTS_LOCALE_COOKIE_NAME } from 'core/utils/constants'
import CreateApiToken from './api-token/CreateApiToken'
import UpdateApiToken from './api-token/UpdateApiToken'
import CreateClientAuthCertificate from './client-auth-certificate/CreateClientAuthCertificate'
import UploadClientAuthCertificate from './client-auth-certificate/UploadClientAuthCertificate'
import { getItemFromLS, setItemToLS } from 'shared/helpers/LocalStorage'
import { translate } from 'shared/helpers/utils'


const EditUserSideRail = ({ user, showSideRail, setShowSideRail, sideRailContent, editUser, updateDetails, setServices, profile, setTokens, token, certificates, setCertificates }) => {

  const onCancel = (event) => {
    event.preventDefault()
    setShowSideRail(false)
  }

  const getNotificationMessage = (userName: string) => {
    switch (sideRailContent) {
      case UserUpdateType.UserDetails:
        return <Translate id={'notifications.users.updateUserSuccess'} data={{ userName: userName }} />
      case UserUpdateType.AccountAccess:
        return <Translate id={'notifications.users.editUserGroupSuccess'} data={{ userName: userName }} />
      default:
        return <Translate id={'notifications.users.updateUserSuccess'} data={{ userName: userName }} />
    }
  }
  const replaceLabelsWithTranslation = (filterObj) => {
    const newFilterObj = {};
    Object.keys(filterObj).forEach(key => {
      if (Array.isArray(filterObj[key])) {
        newFilterObj[key] = filterObj[key].map(item => ({
          ...item, label: translate(item.key) as string
        }));
      } else {
        newFilterObj[key] = filterObj[key];
      }
    });
    return newFilterObj;
  }

  const updateFilters = (data, newFilters) => {
    return {
      ...data,
      meta: {
        ...data.meta,
        filters: newFilters
      }
    };
  }

  useEffect(() => {
    if (sessionStorage.getItem("reloaded") && getItemFromLS('dcone-table/user-table-' + profile?.id) !== null) {
      const storedTableData = JSON.parse(getItemFromLS('dcone-table/user-table-' + profile?.id) as string)
      setItemToLS('dcone-table/user-table-' + profile?.id, JSON.stringify(updateFilters(storedTableData, replaceLabelsWithTranslation(storedTableData?.meta?.filters))));
      sessionStorage.removeItem("reloaded")
      window.location.reload()
    }
  }, [])

  const onEdit = (event, groups, userData, setLoading) => {
    event.preventDefault()
    const formData: any = {
      "access_scope": userData.access_scope === IAccessScope.system,
      "first_name": userData.first_name,
      "last_name": userData.last_name,
      "email": userData.email,
      "user_name": userData.user_name,
      "locale": userData.locale,
      "phone": userData.phone,
      "other_phone": userData.other_phone,
      "saml_username": userData.saml_username,
      "oidc_username": userData.oidc_username,
      "group_ids": groups
    }
    const applications: IApplication[] = Object.values(user?.applications)
    const certCentralId = applications?.find(app => app.short_app_code === CERT_CENTRAL_SHORT_APP_CODE)?.id
    const selectedSpCertCentralSpAccounts = applications?.find(app => app.short_app_code === CERT_CENTRAL_SHORT_APP_CODE)?.service_provider_accounts?.map(sp => sp.id)
    if (certCentralId && selectedSpCertCentralSpAccounts && selectedSpCertCentralSpAccounts.length > 0) {
      formData.service_provider_account_ids = { [certCentralId]: selectedSpCertCentralSpAccounts }
    }
    if (user.access_scope !== IAccessScope.system) {
      formData.accounts = user.accounts.map(account => account.id)
      formData.application_ids = applications.map(app => app.id)
    }
    editUser(userData.id, formData, false, getNotificationMessage(userData.first_name + ' ' + userData.last_name)).then(async () => {
      setShowSideRail(false)
      setLoading(false)
      if (userData.id === profile?.id && userData.locale !== profile?.locale) {
        Cookies.set(ACCOUNTS_LOCALE_COOKIE_NAME, userData.locale, { secure: true })
        window.location.reload()
        sessionStorage.setItem("reloaded", "true")
      }
      updateDetails()
    })
  }

  const renderSideRailContent = (updateType: UserUpdateType) => {
    switch (updateType) {
      case UserUpdateType.UserDetails:
        return <UpdateUser user={user} onCancel={onCancel} onEdit={onEdit} />
      case UserUpdateType.AccountAccess:
        return <AccountAccess user={user} onCancel={onCancel} onEdit={onEdit} />
      case UserUpdateType.UserCredentials:
        return <ResetUserCredentials user={user} onCancel={onCancel} />
      case UserUpdateType.UserServices:
        return <UpdateServices user={user} onCancel={onCancel} setServices={setServices} />
      case UserUpdateType.ApiToken:
        return <CreateApiToken onCancel={onCancel} setTokens={setTokens} />
      case UserUpdateType.UpdateApiToken:
        return <UpdateApiToken onCancel={onCancel} setTokens={setTokens} token={token} />
      case UserUpdateType.CreateCertificate:
        return <CreateClientAuthCertificate onCancel={() => setShowSideRail(false)} user={user} certificates={certificates} setCertificates={setCertificates} />
      case UserUpdateType.UploadCertificate:
        return <UploadClientAuthCertificate onCancel={() => setShowSideRail(false)} user={user} certificates={certificates} setCertificates={setCertificates} />
      default:
        break;
    }
  }

  return (
    <SideRail
      className={cn(styles.sideRail, showSideRail && styles.expanded)}
      headline={<h2><Translate id={`notifications.users.details.${sideRailContent}`} /></h2>}
      show={showSideRail}
      onDismiss={() => setShowSideRail(!showSideRail)}
      lightbox
    >
      {renderSideRailContent(sideRailContent)}
    </SideRail>
  )
}

export default connect(null, { editUser })(EditUserSideRail)
